/** Remote identity helpers shared by LiveKit connect / audio policy. */

export function isLiveAvatarIdentity(identity: string | undefined): boolean {
  const id = (identity || '').toLowerCase();
  return id.includes('liveavatar') || id.includes('heygen') || id.includes('avatar');
}

export function isBotIdentity(identity: string | undefined): boolean {
  const id = (identity || '').toLowerCase();
  return id.includes('bot') || id.includes('agent');
}

/**
 * Silent Live Perception observer (publish off).
 * Must never be elected as Pipecat LiveKitTransport `_botId` or haircheck
 * sticks on Connecting… while the conversation bot already speaks.
 */
export function isLivePerceptionIdentity(identity: string | undefined): boolean {
  const id = (identity || '').toLowerCase();
  return id.startsWith('perception-') || id.startsWith('perception_');
}
